import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { css } from "styled-components"
import SectionDivider from "../../../components/shared/section-divider"
import { Block, Grid, Spacer } from "../../atoms/layout-primitives"
import Img from "gatsby-image"
import ContentBlock from "../../molecules/content-block"
import VariantContainer from "../../atoms/variant-container"

export default function HowIPSWorks() {
  const query = useStaticQuery(graphql`
    query {
      image: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/how IPS works/how IPS works.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <SectionDivider />
      <VariantContainer
        variants={[
          css`
            background-color: var(--tricorn-black);
          `
        ]}
      >
      <Grid>
        <Spacer height={{ sm: "48px", md: "64px", lg: "64px" }} />
        <Block 
            col={{ sm: "1 / -1", md: "3 / -3", lg: "1 / 7" }}
            variants={[
                css``,
                css``,
                css`
                    max-width: 560px;
                    max-height: 574px;
                    justify-self: center;
                `
            ]}
        >
          <Img
            fluid={query.image.childImageSharp.fluid}
            alt="Mobile phone with features displayed"
          />
        </Block>
        <Block
            col={{ sm: "1 / -1", md: "2 / -2", lg: "7 / -1" }}
            variants={[
                css``,
                css``,
                css`
                    justify-self: center;
                    align-self: center;
                    padding-right: 3.26%;
                    padding-left: 3.26%;
                `
            ]}
        >
          <ContentBlock.H2
            title="How Indoor Positioning Systems Work"
            description={
              <>
                Using a variety of techniques, indoor positioning technology
                detects the precise location of a user's device. This can be
                accomplished using "on-device" systems accessed directly through
                your mobile device, or paired with sensors installed throughout
                an indoor space.
                <br />
                <br />
                The combination of these two techniques is called "Sensor
                Fusion" and tends to be the most accurate approach to indoor
                positioning today. The location coordinates are ingested by
                these positioning systems which then generate accurate,
                real-time coordinates which are displayed on an indoor map,
                enhancing the indoor experience.
              </>
            }
            variants={[
              css`
                margin-top: 64px;
                text-align: center;
              `,
              css`
                margin-top: 48px;
              `,
              css`
                margin-top: 0;
                text-align: left;
              `,
            ]}
            titleVariants={[
              css`
                color: #fafafa;
              `,
            ]}
            bodyVariants={[
              css`
                color: #f2f2f2;
              `,
            ]}
          />
        </Block>
        <Spacer height={{ sm: "48px", md: "64px", lg: "64px" }} />
      </Grid>
      </VariantContainer>
      <SectionDivider flip />
    </>
  )
}
